/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
const nameSpace = 'USER'
export const isAdmin = `${nameSpace}_isAdmin`
export const isAdminAndManager = `${nameSpace}_isAdminAndManager`
export const isLogin = `${nameSpace}_isLogin`
export const Account = `${nameSpace}_Account`
export const Logout = `${nameSpace}_Logout`
export const superAdmin = `${nameSpace}_superAdmin`
